import * as $form from './_form'
import * as $helpers from './_helpers'
import * as $modal from './_modal'
import { ownerform as $ownerform } from './search'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
    exportTemplateId: string
    gdpr: string
}

var options: IInitOptions

export function init($options: IInitOptions): void {
    options = $options

    $helpers.partialPageInit($('.' + options.pageName))

    $('.' + options.pagePrefix + '-continue').on('click', () => {
        $ownerform.getFile(options.exportTemplateId, options.gdpr, $('.' + options.pagePrefix + '-filename').val() as string, $form.getCheckboxlistValues($('.' + options.pagePrefix + '-excludedead')).join(','))
    })

    $('.' + options.pagePrefix + '-cancel').on('click', () => {
        $modal.hide()
    })
}
